(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.RatingsService = (function(superClass) {
    extend(RatingsService, superClass);

    function RatingsService(http, rootScope, factory) {
      this.http = http;
      this.rootScope = rootScope;
      this.factory = factory;
      this.getCompanyName = bind(this.getCompanyName, this);
      this.updateRatings = bind(this.updateRatings, this);
      this.getProducts = bind(this.getProducts, this);
      this._parseCategories = bind(this._parseCategories, this);
      this.getConfiguration = bind(this.getConfiguration, this);
      null;
    }

    RatingsService.prototype.getConfiguration = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/ratings/get-configuration', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var ref;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            _this._parseCategories(response.data.categories);
          }
          return response;
        };
      })(this));
    };

    RatingsService.prototype._parseCategories = function(categories) {
      var category, col, heading, i, j, k, l, len, len1, len2, m, n, ref, ref1, results;
      results = [];
      for (i = l = 0, len = categories.length; l < len; i = ++l) {
        category = categories[i];
        ref = category.headings;
        for (j = m = 0, len1 = ref.length; m < len1; j = ++m) {
          heading = ref[j];
          ref1 = heading.columns;
          for (k = n = 0, len2 = ref1.length; n < len2; k = ++n) {
            col = ref1[k];
            heading.columns[k] = this.factory.make('Column', col);
          }
          category.headings[j] = this.factory.make('Heading', heading);
        }
        results.push(categories[i] = this.factory.make('Category', category));
      }
      return results;
    };

    RatingsService.prototype.getProducts = function(lineups_id, ids) {
      var params;
      if (ids == null) {
        ids = null;
      }
      params = {
        lineups_id: lineups_id
      };
      if (ids != null) {
        params.ids = ids;
      }
      return this.http.post('backend/portal/ratings/products/load-with-ratings', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, l, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.products;
            for (i = l = 0, len = ref1.length; l < len; i = ++l) {
              props = ref1[i];
              obj = _this.factory.make('ProductWithRatings', props);
              response.data.products[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    RatingsService.prototype.updateRatings = function(lineups_id, products) {
      var params;
      params = {
        lineups_id: lineups_id,
        products: products
      };
      return this.http.post('backend/portal/ratings/ratings/update-ratings', params).then(function(response) {
        return response.data;
      });
    };

    RatingsService.prototype.getCompanyName = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/ratings/get-company-name', params).then(function(response) {
        return response.data;
      });
    };

    return RatingsService;

  })(Service);

}).call(this);
